export const packageList = [
  {
    name: 'fms_kts',
    activeRule: ['fms-kts'],
  },
  {
    name: 'fms',
    activeRule: ['fms', 'expense'],
  },
  {
    name: 'fms_common',
    activeRule: [],
  },
  {
    name: 'fms_flow',
    activeRule: [],
  },
]

export const remoteModuleConfig = {
  dev: ['fms_kts', 'fms', 'fms_common', 'fms_flow'],
  stg: ['fms_kts', 'fms', 'fms_common', 'fms_flow'],
  uat: ['fms_kts', 'fms', 'fms_common', 'fms_flow'],
  prd: ['fms_kts', 'fms', 'fms_common', 'fms_flow'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/fms/index.js